import AuctionCard from 'components/mainCards/auction';
import PrepaymentCard from 'components/mainCards/prepayment';
import SaleCard from 'components/mainCards/sale';
import {timeFromCreated} from 'utilities/helper/timeFromCreated';
import EmptyBack from 'assets/images/noImage/background store 4.svg';
import {ReactComponent as Grade1} from 'assets/images/grade/grade1.svg';
import {ReactComponent as Grade2} from 'assets/images/grade/grade2.svg';
import {ReactComponent as Grade3} from 'assets/images/grade/grade3.svg';
import {ReactComponent as Grade4} from 'assets/images/grade/grade4.svg';
import {ReactComponent as Grade5} from 'assets/images/grade/grade5.svg';
import {ReactComponent as Grade6} from 'assets/images/grade/grade6.svg';
import {ReactComponent as Grade7} from 'assets/images/grade/grade7.svg';
import {ReactComponent as Grade8} from 'assets/images/grade/grade8.svg';
import {ReactComponent as Grade9} from 'assets/images/grade/grade9.svg';
import {ReactComponent as Grade10} from 'assets/images/grade/grade10.svg';
import SimpleCard from 'components/mainCards/simpleCard';

export const convertorSubCardType: Record<
  string,
  (post: ICardData, homeCards?: boolean) => JSX.Element
> = {
  auction: (post, homeCards) => {
    return (
      <AuctionCard
        isExpired={post.isExpired}
        isSold={post.isSold}
        wrapperClassName="!w-full"
        title={post.title}
        image={post.image ? post?.image : EmptyBack}
        createdDate={timeFromCreated(post.created_at)}
        proposal={post.proposal}
        soldTime={post?.expire_date}
        homeCards={homeCards}
        grade={post.grade}
        is_distinguished = {post?.is_distinguished && post?.is_distinguished}
      />
    );
  },
  sale: (post, homeCards) => {
    return (
      <SaleCard
        isExpired={post.isExpired}
        isSold={post.isSold}
        wrapperClassName="!w-full"
        title={post.title}
        image={post.image ? post?.image : EmptyBack}
        createdDate={timeFromCreated(post.created_at)}
        price={post.sale ? post.sale.realtime_price : 0}
        soldTime={post?.expire_date}
        homeCards={homeCards}
        grade={post.grade}
        negotiated_price={post.negotiated_price}
        is_distinguished = {post?.is_distinguished && post?.is_distinguished}
      />
    );
  },
  prepayment: (post, homeCards) => {
    return (
      <PrepaymentCard
        isExpired={post.isExpired}
        isSold={post.isSold}
        size={post.size}
        wrapperClassName="!w-full"
        title={post.title}
        image={post.image ? post?.image : EmptyBack}
        createdDate={timeFromCreated(post.created_at)}
        price={post.price}
        soldTime={post?.expire_date}
        homeCards={homeCards}
        grade={post.grade}
        negotiated_price={post.negotiated_price}
        is_distinguished = {post?.is_distinguished && post?.is_distinguished}
      />
    );
  },
  simple: (post, homeCards) => {
    return (
      <SimpleCard
        isExpired={post.isExpired}
        isSold={post.isSold}
        wrapperClassName="!w-full"
        createdDate={timeFromCreated(post.created_at)}
        image={post.image ? post?.image : EmptyBack}
        title={post.title}
        price={`${post.price}`}
        state={post.state}
        city={post.city}
        degree={post.grade}
        homeCards={homeCards}
        negotiated_price={post.negotiated_price}
        is_distinguished = {post?.is_distinguished && post?.is_distinguished}
      />
    );
  },
};
export const gradeConvertor: Record<string, JSX.Element> = {
  1: <Grade1 />,
  2: <Grade2 />,
  3: <Grade3 />,
  4: <Grade4 />,
  5: <Grade5 />,
  6: <Grade6 />,
  7: <Grade7 />,
  8: <Grade8 />,
  9: <Grade9 />,
  10: <Grade10 />,
};
